import SiteLayout from '@/components/feature/SiteLayout';
import useSeo from '@/hooks/useSeo';
import { filterArticles, getFeaturedArticles, getAllSpecials } from '@/utils/data';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import LatestNews from './components/LatestNews';
import HotSpecials from './components/HotSpecials';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  useSeo({
    title: '51吃瓜网—今日最新吃瓜资源资讯平台',
    description:
      '51吃瓜网为您实时提供今日吃瓜资源及最新娱乐资讯，涵盖热点新闻、爆料报道和网络趣闻，助您快速了解娱乐圈动态。',
    keywords: '51吃瓜网,吃瓜资源,今日吃瓜,娱乐资讯,热点新闻,爆料,网络趣闻,最新动态',
  });

  const featured = getFeaturedArticles(5);
  const latest = filterArticles({ sort: 'latest' }).slice(0, 6);
  const ranking = filterArticles({ sort: 'views' }).slice(0, 6);
  const specials = [...getAllSpecials()].sort((a, b) => b.views - a.views).slice(0, 3);

  return (
    <SiteLayout>
      <HeroCarousel articles={featured} />
      <CategoryEntries />
      <LatestNews latest={latest} ranking={ranking} />
      <HotSpecials specials={specials} />
      <SiteIntro />
    </SiteLayout>
  );
}